var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "#EAFF99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.347 8.66L10.347 17.66C10.2686 17.7386 10.1755 17.8009 10.0729 17.8435C9.97041 17.886 9.8605 17.9079 9.7495 17.9079C9.6385 17.9079 9.52858 17.886 9.42606 17.8435C9.32353 17.8009 9.2304 17.7386 9.152 17.66L5.214 13.722C5.06568 13.5614 4.98528 13.3496 4.98967 13.131C4.99406 12.9125 5.08289 12.7041 5.23754 12.5496C5.39219 12.395 5.60065 12.3064 5.81923 12.3022C6.0378 12.298 6.24952 12.3785 6.41 12.527L9.75 15.867L18.153 7.466C18.2314 7.3874 18.3245 7.32502 18.427 7.28241C18.5295 7.23979 18.6394 7.21779 18.7504 7.21765C18.8614 7.21751 18.9714 7.23924 19.074 7.28159C19.1766 7.32395 19.2699 7.3861 19.3485 7.4645C19.4271 7.5429 19.4895 7.63601 19.5321 7.73852C19.5747 7.84103 19.5967 7.95093 19.5968 8.06194C19.597 8.17295 19.5753 8.2829 19.5329 8.38552C19.4905 8.48813 19.4284 8.5814 19.35 8.66L19.348 8.658L19.347 8.66Z",
    fill: "#112C22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.f3c516c4a8214d4728f2b3bf6f366d7e.svg";
export { ForwardRef as ReactComponent };